export enum StorageTypes {
  "localstorage" = "localstorage",
  "sessionstorage" = "sessionstorage",
}
